import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {forkJoin, Observable, of} from 'rxjs';
import {timeout} from 'rxjs/operators';
import {IQAPI_HTTP_REQUEST_TIMEOUT} from '../../../environments/environment';
import {
	InParamFavorites,
	FileInfoObj,
	FileObj,
	GetConditionsObj,
	SearchObjectsExObj,
	ConfigurationObject,
	FilesGetResponseObj,
	LockObject,
	UnlockObject,
	CheckRelationsObject,
	SearchRelationsObject, SearchRelationsExObject, SearchQueryParamsSearchFieldsOnly
} from '../../interfaces/interfaces.regisafe';
import {ToastController} from '@ionic/angular';
import {FileTransferObject, FileUploadOptions, FileTransfer} from '@awesome-cordova-plugins/file-transfer/ngx';
import {MessagesService} from '../messages/messages.service';
import {FileSystemService} from '../filesystem/filesystem.service';
import {catchError} from 'rxjs/Operators';
import {AppConfig} from '../../app.config';

@Injectable({
	providedIn: 'root'
})
export class IQApiService {

	public configuration: ConfigurationObject;

	toast: HTMLIonToastElement;
	alert: HTMLIonAlertElement;

	constructor(private httpClient: HttpClient,
				public toastCtrl: ToastController,
				private transfer: FileTransfer,
				private msgService: MessagesService,
				private fileSytemService: FileSystemService,
				public appConfig: AppConfig) {
		this.configuration = this.appConfig.getConfig();
	}

	/**
	 * orgaManagerGetConditions()
	 *
	 * Liefert zahlreiche Informationen zur den Rahmenbedingungen und der Konfiguration des OrgaManager-Moduls, ergänzt
	 * um weitere system- und benutzerbezogene Informationen.
	 *
	 * @param body
	 */
	orgaManagerGetConditions(body: GetConditionsObj): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.GetConditions';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json', reportProgress: true, observe: 'response'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	/**
	 * orgaManagerSearchObjectsEx()
	 *
	 * Führt am Server eine Suche nach Objekten der Organisationsstruktur durch, sortiert die Ergebnisse und liefert die
	 * Datensätze aller oder eines Teils der gefundenen Objekte zurück. Das Suchergebnis wird am IQ-Server gecached, so
	 * dass ein weiterer Aufruf von SearchObjectsEx mit denselben Suchkriterien innerhalb derselben Session keine
	 * erneute Datenbanksuche verursacht. Dadurch ist es möglich, dass z.B. erst die ersten 20 Treffer und später die
	 * nächsten 20 Treffer usw. abgefragt werden. Zudem verhindert der Cache, dass zweimal dieselbe Suche gleichzeitig
	 * abläuft: in diesem Fall würde der zweite Aufruf von SearchObjectsEx warten, bis die erste Suche abgeschlossen
	 * ist. Suchergebnisse im Cache werden verworfen, wenn diese ein gewisses Alter erreicht haben oder eine gewisse
	 * Maximalzahl gecachter Suchen erreicht wurde. Zudem werden Suchergebnisse automatisch aus dem Cache entfernt, wenn
	 * in der selben Session Objekte neu angelegt, geändert oder gelöscht werden, sowie wenn in einer beliebigen Session
	 * ein Objekt geändert oder gelöscht wird, das sich in der Trefferliste des Cache befindet.
	 *
	 * @param body
	 */
	orgaManagerSearchObjectsEx(body: SearchObjectsExObj): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.SearchObjectsEx';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerReadObject(body: any): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.ReadObject';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerReadObjects(body: any): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.ReadObjects';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerWriteObject(fileEntry, type, parameter) {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.WriteObject';
		const fileTransfer: FileTransferObject = this.transfer.create();
		const transferOption: FileUploadOptions = {
			fileKey: 'binary',
			fileName: fileEntry.name,
			mimeType: type,
			httpMethod: 'POST',
			chunkedMode: false,
			params: parameter
		};

		fileTransfer.onProgress((event) => {
			console.log('orgaManagerWriteObjectAdd.onProgress: ', event.loaded);
		});

		fileTransfer.upload(fileEntry.uri, url, transferOption, true)
			.catch((e) => {
				console.log('transferObj error: ', e);
			})
			.then((result) => {
				console.log('transferObj result: ', result);
			});
	}

	orgaManagerHandFile(fileEntry, token, type) {

		const fileTransfer: FileTransferObject = this.transfer.create();

		const transferOption: FileUploadOptions = {
			fileKey: 'binary',
			fileName: fileEntry.name,
			mimeType: type,
			httpMethod: 'POST',
			chunkedMode: false,
			params: {
				apiID: this.configuration.iqapiAppId,
				sessionToken: token,
				fileName: fileEntry.name,
				dontOpenDlg: 0
			}
		};

		console.log('### OrgaManagerHandFile fileTransfer: ', fileTransfer);
		// console.log('### OrgaManagerHandFile parameterHandFile: ', parameterHandFile);

		fileTransfer.onProgress((event) => {
			console.log('transferObj.onProgress: ', event.loaded);
			// this.toast.message = String(event.loaded);
		});

		const url = this.configuration.iqapiEndpoint + '/OrgaManager.HandFile';

		fileTransfer.upload(fileEntry.uri, url, transferOption, true)
			.catch((e) => {
				console.log('transferObj error: ', e);
				// this.msgService.sendMessage({context: 'api:upload:handfile', file: fileEntry.name, upload: false});
				// this.toast.dismiss();
			})
			.then((result) => {
				console.log('transferObj result: ', result);
				// this.msgService.sendMessage({context: 'api:upload:handfile', file: fileEntry.name, upload: true});
				// this.toast.dismiss();
				// this.fileSytemService.deleteFile(fileEntry);
			});
	}

	orgaManagerAddObject(body): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.WriteObject';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerGetFileInfo(body: FileInfoObj): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.GetFileInfo';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerGetFile(body: FileObj) {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.GetFile';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	OrgaManagerGetFile_Get(token) {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.GetFile';
		const params = '?apiID=' + this.configuration.iqapiEndpoint + '&sessionToken=' + token + '&osId=Schriftgutverwaltung&objID=2110:220896&fileName=tet.pdf'
		return this.httpClient
			.get(url + params)
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	/**
	 * orgaManagerGetFavorites()
	 *
	 * Holt die Favoriten der übergebenen Oragstrukturen über die IQAPI. Die OrgaStrukturen
	 * werden als Array (Liste) übergeben.
	 * z.B. ['Aktenplanverwaltung', 'VorgangsVerwaltung', 'Sitzungsverwaltung']
	 * Das Ergebnis ist entsprechend dem übergebenen Array sortiert.
	 *
	 * @param token
	 * @param orgaStructs
	 */
	orgaManagerGetFavorites(token: string, orgaStructs: Array<string>): Observable<any> {
		const favoritesRoutes = [];
		orgaStructs.forEach((structure) => {
			const body: InParamFavorites = {
				apiID: this.configuration.iqapiAppId,
				osId: structure,
				sessionToken: token
			};
			const url = this.configuration.iqapiEndpoint + '/OrgaManager.GetFavorites';
			favoritesRoutes.push(this.httpClient.post(url, body, {headers: {}, responseType: 'json'}));
		});

		return forkJoin(favoritesRoutes).pipe(
			catchError(error => of(error))
		);
	}

	/**
	 * orgaManagerGlobalSearchEx()
	 *
	 * Führt eine Suche über alle vorhandenen (bzw. übergebenen) Orgastrukturen durch.
	 * Gesucht wird in den in 'searchFieldObj' übergebenen Feldern. Es wird ein Array
	 * von Objekten zurückgegeben unabhängig, ob etwas gefunden wurde oder nicht.
	 * Gab es einen Treffer, enthält das entsprechenden Object einen Schlüssel 'objDatasets'
	 * mit dem Ergebnis der Suche oder, wenn für die OrgaStruktur nichts gefunden wurde,
	 * folgenden Eintrag: 'totalCount: 0'.
	 *
	 * @param token
	 * @param orgaStructs
	 * @param searchFieldObj
	 */
	orgaManagerSearchExGlobal(token: string, orgaStructs: Array<string>, searchFieldObj: any): Observable<any> {
		const routes = [];
		orgaStructs.forEach((structure: string) => {
			const body: SearchQueryParamsSearchFieldsOnly = {
				apiID: this.configuration.iqapiAppId,
				osId: structure,
				sessionToken: token,
				searchFields: searchFieldObj,
				addosId: 1
			};

			const url = this.configuration.iqapiEndpoint + '/OrgaManager.SearchObjectsEx';
			routes.push(this.httpClient.post(url, body, {headers: {}, responseType: 'json'}));
		});

		return forkJoin(routes).pipe(
			catchError((error) => of(error))
		);
	}

	orgaManagerGetSavedSearchCriteriaList(token: string, orgaStructs: Array<string>): Observable<any> {
		const savedSearchCriteriaList = [];
		orgaStructs.forEach((structure) => {
			const body: InParamFavorites = {
				apiID: this.configuration.iqapiAppId,
				osId: structure,
				sessionToken: token
			};
			const url = this.configuration.iqapiEndpoint + '/OrgaManager.GetSavedSearchCriteriaList';
			savedSearchCriteriaList.push(this.httpClient.post(url, body, {headers: {}, responseType: 'json'}));
		});

		return forkJoin(savedSearchCriteriaList).pipe(
			catchError(error => of(error))
		);
	}


	async uploadMessage() {
		this.toast = await this.toastCtrl.create({
			message: 'Upload'
		});
		this.toast.present();
	}

	// field definition
	getFields(structure: string) {

		let fields: any = [];

		switch (structure.toLowerCase()) {

			case 'aktenplanverwaltung':
				fields = ['Aktenzeichen', 'Vorgangskennung', 'Text', 'SubVorgangsverwaltung', 'SubSchriftgutverwaltung',
					'SubAktenplanverwaltung', 'ArtID', 'Fussnote', 'Haushaltsstelle', 'Hinweise', 'HistAktenzeichen',
					'Produktkennung', 'Schlagworte', 'Zustaendigkeit', '_SYMBFARBE', '_FARBE', 'ZUGRIFF', '_ObjId'];
				break;

			case 'vorgangsverwaltung':
				fields = ['Aktenzeichen', 'Vorgangskennung', '_ObjId', 'Text', 'SubSchriftgutverwaltung',
					'SubVorgangsverwaltung', 'BeginnDatum', 'EndeDatum', 'Adresskennung', 'ArtID', 'AufbArchiv',
					'AufbFrist', 'AufbOrt', 'AufbRegistratur', 'AufbVernichten', 'Barcode', 'BeginnDatum', 'EndeDatum',
					'Hinweise', 'Schlagworte', 'Status', 'Zustaendigkeit', '_VERWEIS_AKTENPLAN',
					'_SYMBFARBE', '_FARBE'];
				break;

			case 'schriftgutverwaltung':
				fields = ['Aktenzeichen', 'Vorgangskennung', '_ObjId', 'Text', 'SubVorgangsverwaltung',
					'SubSchriftgutverwaltung', 'Adresskennung', 'Datum', 'ADatum', 'EndeDatum', 'ArtID', 'AufbArchiv',
					'AufbFrist', 'AufbOrt', 'AufbRegistratur', 'AufbVernichten', 'Barcode', 'Datum', 'Hinweise',
					'Internet', 'InternetBis', 'InternetFreigabe', 'Zugriff', 'InternetVon', 'Kategorie', 'Kennung',
					'Postausgang', 'PostDatum', 'Posteingang', 'PostKennung', 'Sachbearbeiter', 'Verwaltungskennung',
					'Grundstückskennung', 'SachbErsteller', 'SachbUnterzeichner', 'Schlagworte',
					'Schriftstückidentifikation', 'Status', 'Verknüpfungsart', '_VERWEIS_AKTENPLAN',
					'_SYMBFARBE', '_FARBE'];
				break;

			case 'adressverwaltung':
				fields = ['Adresskennung', 'Vorgangskennung', 'SubVorgangsverwaltung', 'SubSchriftgutverwaltung',
					'SubAdressverwaltung', 'SubVerteilerverwaltung', 'Strasse', 'StrPLZ', 'StrOrt', 'StrLand',
					'TelefonPrivat', 'TelefonGesch', 'TelefonMobil', 'MailPrivat', 'MailGesch', 'WebAdresse',
					'FaxGesch', 'Abteilung', 'Anrede', 'Vorname', 'Nachname', 'Anrede2', 'Nachname2', 'Vorname2',
					'PartnerAnrede', 'GebDatum', 'GebLand', 'GebName', 'GebOrt', 'Geschlecht', 'Hinweise', 'Nachtitel',
					'Nachtitel2', 'Namenszusatz', 'Namenszusatz2', 'Ortsteil', 'Postfach', 'Schlagworte',
					'Staatsangehoerigkeit', 'StrInfoPrivat', 'StrassePrivat', 'StrPLZPrivat', 'StrOrtPrivat',
					'FaxPrivat', 'ArtId', 'MailAp', 'FaxAp', 'TelefonAp', 'MobilAp', '_ObjId', '_SYMBFARBE', '_FARBE',
					'Text', 'ArtID', 'Kategorien', 'Name1'];
				break;

			case 'sitzungsverwaltung':
				fields = ['Text', 'Artid', 'Sitzungsdatum', 'Sitzungsstatus', 'Sitzungsgremium', 'Sitzungsraum',
					'Sitzungsuhrzeitvon', 'Sitzungsuhrzeitbis', 'Sitzung_Tops', 'Zustaendigkeit', 'Sitzungsbezeichnung',
					'Sitzungskennung', 'Aktenzeichen', 'Terminobjid', 'Besondbezeichnung', 'To_Abgeschlossen',
					'Sitzungsnummer', 'Subschriftgutverwaltung', '_ObjId', '_SYMBFARBE', '_FARBE'];
				break;

			default:
				fields = ['Text', 'SubVorgangsverwaltung', 'SubSchriftgutverwaltung', 'SubAktenplanverwaltung'];
		}

		return fields;

	}

	getBinary(path: string): Observable<any> {
		return this.httpClient
			.get(this.configuration.iqapiDomain + path, {responseType: 'arraybuffer'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	// Dokumenten-Sperren
	orgaManagerLockObject(body: LockObject): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.LockObject';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerUnlockObject(body: UnlockObject): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.UnlockObject';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerCheckRelations(body: CheckRelationsObject): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.CheckRelations';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerSearchRelations(body: SearchRelationsObject): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.SearchRelations';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	orgaManagerSearchRelationsEx(body: SearchRelationsExObject): Observable<any> {
		const url = this.configuration.iqapiEndpoint + '/OrgaManager.SearchRelationsEx';
		return this.httpClient
			.post(url, body, {headers: {}, responseType: 'json'})
			.pipe(
				timeout(IQAPI_HTTP_REQUEST_TIMEOUT)
			);
	}

	/**
	 * getIconsInAssetsFolder()
	 *
	 * Durchsucht den angebenen Ordner nach Icons und übergibt das Ergebnis
	 * als Promise
	 *
	 * @param urls
	 */
	getIconsInAssetsFolder(urls: Array<any>, key: string): Promise<any> {
		console.log('getIconsInAssetsFolder: ', urls);
		const routes = [];
		urls.forEach((url) => {
			routes.push('assets/icons/regisafe/' + url[key] + '.svg');
		});
		return Promise.all(routes.map(route => fetch(route)));
	}


	// /**
	//  * expandResultObject()
	//  *
	//  * ergänzt das Ergebnis der IQAPI-Anfrage (orgaManager.GetSavedSearchCriteriaList) um die Felder
	//  * osStruct, osStructName und osSortIndex.
	//  * Übergeben wird zusätzlich ein Schlüssel aus dem erwarteten Ergebnis, ein Vergleichs-Operator und der
	//  * Wert auf den mitteles der Mthode conditioner() geprüft werden soll
	//  *
	//  * @param result
	//  * @param structures
	//  * @param keyinresult
	//  * @param operator
	//  * @param value
	//  */
	// expandResultObject(result, structures, keyinresult, operator, value): Array<any> {
	// 	const resultObj = result;
	// 	const tempArr: Array<any> = [];
	// 	Object.keys(resultObj).forEach((key, index) => {
	// 		const osStructName = this.storageService.getOsStructNameFromConditionsSync(structures[index]);
	// 		const osSortIndex = this.storageService.getOsSortIndexFromConditionsSync(structures[index]);
	// 		console.log('result[key][keyinresult]: ', result[key][keyinresult]);
	//
	// 		if (this.conditioner(result[key][keyinresult], operator, value)) {
	// 			result[key].osStruct = structures[index];
	// 			result[key].osStructName = osStructName;
	// 			result[key].osSortIndex = osSortIndex;
	// 			tempArr.push(result[key]);
	// 		}
	// 	});
	//
	// 	const sortedTempArr = tempArr.sort((a, b) => {
	// 		if (a.osSortIndex < b.osSortIndex) {
	// 			return -1;
	// 		}
	// 		if (a.osSortIndex > b.osSortIndex) {
	// 			return 1;
	// 		}
	// 		return 0;
	// 	});
	// 	return sortedTempArr;
	// }
	//
	// /**
	//  * conditioner()
	//  *
	//  * Vergleicht zwei Werte mit dem übergebenen Operator und gibt das Ergebnis als Boolean zurück
	//  *
	//  * @param value1
	//  * @param value2
	//  * @param operator
	//  */
	// conditioner(value1: any, value2: any, operator: string): boolean {
	// 	let condition: boolean;
	// 	if (operator === '!==') {
	// 		condition = value1 !== value2;
	// 	} else if (operator === '>') {
	// 		condition = value1 > value2;
	// 	} else {
	// 		condition = false;
	// 	}
	// 	return condition;
	// }

}
